import React, {ReactNode} from 'react';
import {Link, useLocation} from 'react-router-dom';

import useCurrentProject from 'App/features/project/hooks/useCurrentProject';
import HomeButton from 'Pages/app/header/home_button';

const ProjectEditionNav = (): ReactNode => {
  const {search} = useLocation();
  const project = useCurrentProject();

  return (
    <div className="flex items-center justify-between bg-gray-900 px-2 py-1 font-semibold text-gray-100">
      <div className="flex items-center gap-x-3">
        <HomeButton fullLogoClassName="[&_path]:fill-white" />
        <span>EDITION</span>
      </div>
      <div>{project?.address}</div>
      <Link
        to={`../summary${search}`}
        className="mr-1 text-inherit transition-colors hover:text-gray-300 hover:no-underline"
        relative="path"
      >
        <i className="fa-solid fa-xmark block h-[27px] cursor-pointer text-3xl" />
      </Link>
    </div>
  );
};

export default ProjectEditionNav;
